import { Button, Tag, Col, DatePicker, Divider, Dropdown, Form, Input, InputNumber, Radio, Row, Select, Space, Table, Tabs } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { Link, useLoaderData, useNavigate, useOutletContext } from 'react-router-dom';
import EditableTable from '../../components/EditableTable';
import RowEditableTable from '../../../globalComponents/RowEditableTable';
import useInventoryAdjustmentAPI from '../../apis/inventoryAdjustmentAPI';
import { genUniqueNumbers } from '../../../utils/genUniqueID';
import AdjustmentReason from '../../modals/AdjustmentReasonModal';
import EventEmitter from '../../../utils/eventEmitter';
import { Pagination } from 'flowbite-react';
import { IoIosArrowBack } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";
import { MdFilterAlt } from "react-icons/md";
import DebounceSelect from '../../components/DebounceSelect';
import Axios from '../../utils/axios';
import dayjs from 'dayjs';
import AuthContext from '../../../utils/AuthContext';


const columns = [
  {
    title: 'Location',
    dataIndex: 'location_id',
    key: 'location_id',
    editable: true,
    width: '15%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Product',
    dataIndex: 'product_id',
    key: 'product_id',
    editable: true,
    width: '15%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Package',
    dataIndex: 'package_id',
    key: 'package_id',
    editable: true,
    width: '15%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'On Hand',
    dataIndex: 'available_quantity',
    key: 'available_quantity',
    // editable: true,
    width: '10%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Counted Quantity',
    dataIndex: 'counted_quantity',
    key: 'counted_quantity',
    editable: true,
    width: '10%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
  },
  {
    title: 'Difference',
    dataIndex: 'quantity_difference',
    key: 'quantity_difference',
    // editable: false,
    width: '10%',
    className: 'whitespace-nowrap font-medium dark:text-white',
    render: (_, record) => <span className={record.quantity_difference > 0 ? 'text-[#04c910]' : record.quantity_difference < 0 && 'text-red-600'}>{record.quantity_difference}</span>
  },
  {
    title: 'Accounting Date',
    dataIndex: 'accounting_date',
    key: 'accounting_date',
    editable: true,
    width: '10%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Scheduled Date',
    dataIndex: 'scheduled_date',
    key: 'scheduled_date',
    editable: true,
    width: '10%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  // {
  //   title: 'User',
  //   dataIndex: 'user_id',
  //   key: 'user_id',
  //   editable: true,
  //   className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  // },
  {
    title: '',
    key: 'operation',
    editable: false,
    fixed: 'right',
    width: 100,
    className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',
    render: (_, record) => (
      <Link className='h-full w-full' to={'/inventory/inventory-adjustments'}>
        EDIT
      </Link>
    )
  }
]


// const items = [
//   {
//     key: 'To Do',
//     label: 'To Do',
//   },
//   {
//     key: 'Done',
//     label: 'Done',
//   },
//   {
//     type: 'divider'
//   },
//   {
//     key: 'Incoming',
//     label: 'Incoming'
//   },
//   {
//     key: 'Outgoing',
//     label: 'Outgoing'
//   }, 
//   {
//     key: 'Internal',
//     label: 'Internal'
//   }
// ];

const items = [
  {
    key: 'Internal',
    label: 'Internal'
  },
  {
    key: 'Transit',
    label: 'Transit'
  },
];


const InventoryAdjustments = () => {
  const {stock, products, locations} = useLoaderData();
  const { user } = useContext(AuthContext);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [editingKey, setEditingKey] = useState('');
  const [adjustments, setAdjustments] = useState(stock);
  const { success, error } = useOutletContext();
  const { create, update, apply } = useInventoryAdjustmentAPI();
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [searchItems, setSearchItems] = useState({});
  const navigate = useNavigate();
  
  const onClicks = (record) => {
    // let data = {...record};
    // data['scheduled_date'] = new Date(data['scheduled_date']).toLocaleDateString();
    // EventEmitter.dispatch('openinvenreason', {open: true, data: record});
    // // create(record, success)
    // console.log(data);
    
  }

  const handleSave = async (record) => {
    try {
      let data = {...record};
      data['scheduled_date'] = new Date(data['scheduled_date']).toLocaleDateString();
      data.user_id = user.id;
      if (data.save) {
        // const product = products.
      }else {
        if (stock.length > 0) {
          const item = stock.find(prod => (prod.location_id === data.location_id) && (prod.product_id === data.product_id));
          if (data.event === 'CLEAR') {
            // console.log(data);
            await update(data, success);
            return;
          }else {
            if (item) {
              data['event'] = 'UPDATE';
              data['id'] = item.id;
              data['status'] = 'save';
              data['inventory_location'] = data.inventory_location;
              if (data.id === undefined) {
                data['event'] = 'CREATE';
              }
            }else {
              data['event'] = 'NEW_STOCK';
              await update(data, success);
              return;
            }
          }
        }else {
          data['event'] = 'CREATE';
        }
      }
      
      
        // EventEmitter.dispatch('openinvenreason', {open: true, data: data});

      // console.log(data);
      await update(data, success);
    }catch (err) {
      throw err;
    }
  }



  const addLine = () => {
    let adjustments_ = [...adjustments];
    let obj = {
      key: genUniqueNumbers(10),
      location_id: '',
      product_id: '',
      package_id: '',
      quantity: 0,
      counted_quantity: 0,
      quantity_difference: 0,
      save: true,
      accounting_date: dayjs().toDate(), 
      scheduled_date: dayjs().toDate(),
      user_id: '',
    };
    adjustments_.push(obj);
    setAdjustments(adjustments_);
    setEditingKey(adjustments.length + 1);
  }


  console.log(adjustments)
  const onSelectChange = (newSelectedRowKeys) => {
    console.log('selectedRowKeys changed: ', newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const hasSelected = selectedRowKeys.length > 0;

  const openAdjustmentReason = () => {
    let toAdjust = [];
    adjustments.forEach(adj => {
      if (selectedRowKeys.includes(adj.key) && adj.status === 'save') {
        toAdjust.push(adj);
      }else {
        setSelectedRowKeys([]);
        return;
      }
    });
    console.log(toAdjust);
    onClick(toAdjust);
    // EventEmitter.dispatch('openinvenreason', {open: true, data: toAdjust});

  }

  const onClick = (toAdjustList) => {
    // let data = {...record};
    if (toAdjustList.length > 0) {
      let invAdjustments = [];
      toAdjustList.forEach((item, idx) => {
        let data = {...item};
        data['scheduled_date'] = new Date(data['scheduled_date']).toLocaleDateString();
        delete data['status'];
        data['event'] = 'UPDATE';
        data['status'] = 'applied';
        invAdjustments.push(data);
      });

      EventEmitter.dispatch('openinvenreason', {open: true, data: invAdjustments});
    }else {
      let data = {...toAdjustList};
      data['scheduled_date'] = new Date(data['scheduled_date']).toLocaleDateString();
        delete data['status'];
        const item = stock.find(prod => (prod.location_id === data.location_id) && (prod.product_id === data.product_id));
        data['event'] = 'UPDATE';
        data['id'] = item.id;
        data['status'] = 'applied';
        data['inventory_location'] = item.inventory_location;
        console.log(data)
      
      EventEmitter.dispatch('openproinvenreason', {open: true, data});
    }
  }

  const onChangeSelectedFilter = (item, key, keyPath, e) => setSelectedFilters(item.selectedKeys);
  const onPageChange = (page) => setCurrentPage(page);
 
  async function fetchUserList(username) {
    console.log('fetching user', username);
    return Axios(`products/search?query=${username}`)
      .then((response) => response.data)
      .then((res) =>
        res.map((product) => ({
          label: `${product.name}`,
          value: product.seo,
        })),
      );
  }

  useEffect(() => {
    EventEmitter.subscribe('adjustment_response', data => {
      navigate(0);
    });
    return () => EventEmitter.unsubscribe('adjustment_response');
  },[])
  // console.log(searchItems?.stock);
  return (
    <div>
      <div className='mx-4 columns-2'>
        <div className='column'><h3 className='font-bold'>Inventory Adjustments</h3></div>
        <div className='column bg-white dark:bg-gray-900'>
          {/* <Input addonBefore={<MdFilterAlt />}  defaultValue="mysite" /> */}

          <DebounceSelect
            mode='multiple'
            size={'middle'}
            placeholder='Filter'
            value={selectedFilters}
            selectedFilters={selectedFilters}
            setSelectedFilters={setSelectedFilters}
            className='w-full'
            fetchOptions={fetchUserList}
            showSearch
            setSearchItems={setSearchItems}
            // onSearch={v => console.log(v)}
            
          />
        </div>
      </div>
      <div className='columns-2 mx-4 my-2'>
        <div className='column'>
          <Button className='' size={'sm'} onClick={addLine}>New</Button>
          {hasSelected && <Button size='sm' className='ms-3' type='text' onClick={openAdjustmentReason}>APPLY</Button>}
          {hasSelected && <Button size='sm' className='ms-3' type='text'>REQUEST A COUNT</Button>}
        </div>
        <div className='dark:bg-gray-900 column'>
          <Dropdown 
            menu={{
              onSelect: onChangeSelectedFilter,
              onDeselect: onChangeSelectedFilter,
              items: items, 
              selectable: true, 
              multiple: true, 
              selectedKeys: selectedFilters
            }} 
            className='flex items-center w-max'
            
            >
            <span><MdFilterAlt />Filters</span>
          </Dropdown>
          <div className='flex justify-end items-center overflow-x-auto'>
            <span className='text-sm me-2'>1-20 / 20</span>
            <Button type='text' size='small' icon={<IoIosArrowBack />} />
            <Button type='text' size='small' icon={<IoIosArrowForward />} />
          </div>
        </div>
      </div>
      <RowEditableTable
        rowSelection={rowSelection}
        dataSource={searchItems?.stock?.length > 0 ? searchItems?.stock : adjustments}
        setDataSource={setAdjustments}
        columns={columns}
        apiSave={handleSave}
        handlenavigate={()=> {}}
        // addLine={addLine}
        // option1={[]}
        // option2={[]}
        editingKey={editingKey}
        setEditingKey={setEditingKey}
        options={{products: products, users: [], locations: locations}}
        onClick={onClick}
        triggers={[]}
        routes={[]}
      />
      <AdjustmentReason create={apply} success={success}/>
    </div>
  )
}

export default InventoryAdjustments;